import { render, staticRenderFns } from "./PageQuestion.vue?vue&type=template&id=161ff3e4&scoped=true"
import script from "./PageQuestion.vue?vue&type=script&lang=js"
export * from "./PageQuestion.vue?vue&type=script&lang=js"
import style0 from "./PageQuestion.vue?vue&type=style&index=0&id=161ff3e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ff3e4",
  null
  
)

export default component.exports